var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.meetings),function(meeting){return [_c('VideoMeetingCard',{key:meeting.id,staticClass:"tw-mb-4",attrs:{"meeting":meeting,"participants":meeting.participants},on:{"click":_vm.onClick}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }